package org.company.app.data.model

import kotlinx.serialization.Serializable

@Serializable
data class FirebaseRegisterResponse(
    val kind: String,
    val idToken: String,
    val email: String,
    val refreshToken: String? = null, // Add this line
    val expiresIn: String? = null, // Add this line
    val localId: String,
)
